import { EventMarketItemType } from 'src_common/common/websocket2/modelsApi/EventMarkets';
import { Value } from 'src_common/common/mobx-utils/Value';

export class EventMarketsModel {
    private model: Value<Array<EventMarketItemType>>;
    public constructor(model: Value<Array<EventMarketItemType>>) {
        this.model = model;
    }

    public getValue(): Array<EventMarketItemType> {
        return this.model.getValue();
    }
}
